import { get, post, put, remove as httpRemove } from '../Services/http';
import { catchError } from './Error.action';

export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';

const rootRoute = '/api/mypageperson';

export const changeMode = mode => ({
    type: PERSON_CHANGE_MODE,
    payload: {
        mode,
    }
})

export const sortPersons = (id) => (dispatch) => {
    var queryData = "";
    var sortById = document.getElementById('personSortById');
    var sortByName = document.getElementById('personSortByName');
    var isSorted = "True";
    if (id === "Id") {
        sortById.classList.toggle('sorted');
        if (sortById.classList.contains("sorted")) {
            queryData = id + "," + isSorted;
        } else {
            queryData = id + "," + "";
        }
    } else {
        sortByName.classList.toggle('sorted');
        if (sortByName.classList.contains("sorted")) {
            queryData = id + "," + isSorted;
        } else {
            queryData = id + "," + "";
        }
    }


    return post(rootRoute + '/sortPersons', queryData)
            .then(response => response.json())
            .then(result => {
                dispatch(receive(result, "list"));
            })
            .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;
}

export const query = (mode = 'list') => (dispatch) => {
    return get(rootRoute)
        .then(response => response.json())
        .then(result => {
            dispatch(receive(result, mode));
        })
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;
}

export const remove = (personSystemId) => (dispatch) => 
    httpRemove(rootRoute, personSystemId)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;

export const add = (person) => (dispatch) =>
    post(rootRoute, person)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;

export const edit = (person) => (dispatch) =>
    put(rootRoute, person)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;

const receive = (list, mode) => ({
    type: PERSON_RECEIVE,
    payload: {
        list,
        mode,
    },
})

export const setError = error => ({
    type: PERSON_ERROR,
    payload: {
        error,
    },
})